import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import Cookies from 'js-cookie';

/**
 * Componente que protege rutas basándose en la existencia de un token.
 * 
 * - Si hay token, renderiza los componentes hijos con <Outlet />.
 * - Si no hay token, redirige al inicio ("/").
 */
const ProtectedRoute = () => {
    const token = Cookies.get('token');

    return token ? <Outlet /> : <Navigate to="/" />;
};

export default ProtectedRoute;